export const environment = {
	production: true,
	sentryEnvironment: 'production',
	webpackDevServerPort: null, // Not relevant for prod
};
